import { apiClientV2 } from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_API_VMS_URL

const appendPrefixUrl = (prefixUrl = {}, url = '') =>
  [
    `/vendor/${prefixUrl.vendorId}`,
    `/contract/${prefixUrl.contractId}`,
    `/version/${prefixUrl.versionId}`,
    `/rates/${prefixUrl.ratesId}`,
    `${url}`,
  ].join('')

// NOTE: since API doesn't have endpoint for list additional cost,
// we use show rates endpoint and get the additional cost from there
export const get = async (prefixUrl) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: appendPrefixUrl(prefixUrl),
  })

  // If there are no errors
  if (response?.data?.data) {
    return { data: response?.data?.data?.additional_costs }
  }

  return response?.data
}

export const store = async (prefixUrl, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, '/additional-cost'),
    data,
  })

  return response?.data
}

export const update = async (prefixUrl, id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: appendPrefixUrl(prefixUrl, `/additional-cost/${id}`),
    data,
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}

export const deleteMany = async (prefixUrl, data) => {
  const response = await apiClientV2({
    baseURL,
    // TODO: method should be POST instead of DELETE,
    // Change this when API is updated
    method: 'POST',
    url: appendPrefixUrl(prefixUrl, '/additional-cost/delete'),
    data,
  })

  // If no data but status is 200
  if (!response?.data && String(response?.status).startsWith('2')) {
    return 'OK'
  }

  return response?.data
}
